import { CheckCircle2, Clock, RotateCcw, XCircle, type LucideIcon } from 'lucide-react'

import type { MissionSubmissionStatus } from '../types'

type BadgeVariant = 'success' | 'warning' | 'info' | 'destructive'

interface SubmissionStatusConfig {
  slug: MissionSubmissionStatus
  name: string
  icon: LucideIcon
  variant: BadgeVariant
}

// Enum de status de submissão como constante + helper (padrão obrigatório para
// enums de backend exibidos ao usuário). Nunca traduzir status inline no JSX.
export const SUBMISSION_STATUSES: SubmissionStatusConfig[] = [
  { slug: 'approved', name: 'Aprovada', icon: CheckCircle2, variant: 'success' },
  { slug: 'pending', name: 'Pendente', icon: Clock, variant: 'warning' },
  { slug: 'awaiting_correction', name: 'Aguardando correção', icon: RotateCcw, variant: 'info' },
  { slug: 'refused', name: 'Recusada', icon: XCircle, variant: 'destructive' }
]

export function getSubmissionStatus(slug: string): SubmissionStatusConfig {
  return (
    SUBMISSION_STATUSES.find(status => status.slug === slug) ?? {
      slug: slug as MissionSubmissionStatus,
      name: slug,
      icon: Clock,
      variant: 'warning'
    }
  )
}
